import { render } from "./ArticleDetail.vue?vue&type=template&id=65eba4d4"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts"

import "./ArticleDetail.vue?vue&type=style&index=0&id=65eba4d4&lang=css"
script.render = render

export default script